import axios from 'axios'

import axiosRetry from 'axios-retry'

import store from '@/store/store'

const instance = axios.create({
  baseURL: import.meta.env.VITE_BACKEND_ADMIN_URL,
  timeout: 0,
  withCredentials: false, // This is the default
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  allowAbsoluteUrls: false // Added to prevent security vulnerability
})

// Add a request interceptor
instance.interceptors.request.use(
  function (config) {
    const token = store.getters['auth/token']

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// Add a response interceptor
instance.interceptors.response.use(
  function (response) {
    // Do something with response data

    return response.data
  },
  error => {
    if (error.response && error.response.status === 401 && store.getters['auth/token']) {
      store.commit('auth/LOGOUT', store.getters['auth/getNextRoute'])
    }

    return Promise.reject(error)
  }
)

axiosRetry(instance, {
  retries: 0
})

export const apiClient = instance

export { CancelToken } from 'axios'
